import { makeStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) => ({
  avatar: {
    height: 100,
    width: 100,
    marginTop: -50
  }
}))
